import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance, { clearToken, setToken } from '../../utils/axios';
import { fetchStructure } from '../location/operations';
import { UserModel, UserModelProfile } from './model';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { openInfoBox } from '../layout/slice';

export const setUser = createAsyncThunk('user/setUser', async (userModel: UserModel, thunkAPI) => {
  setToken(userModel.token);
  thunkAPI.dispatch(fetchStructure());
  return userModel;
});

export const cleanUser = createAsyncThunk('user/cleanUser', async () => {
  Cookies.remove('user');
  Cookies.remove('password');
  Cookies.remove('structure');
  Cookies.remove('selectedHeadLocationUuid');
  clearToken();
});

export const passwordReminder = async (email: string) => {
  // NOTE: the axios response interceptor (utils/axios.ts) swallows rejections and
  // RESOLVES with the AxiosError instead of throwing, so we inspect the resolved value.
  const result: any = await axiosInstance.put('/v1/user/password-reset?email=' + email);
  if (result?.isAxiosError) {
    const status = result?.response?.status;
    if (status === 404) {
      toast.error('Nie znaleziono użytkownika o podanym adresie email.', { position: 'bottom-left' });
    } else {
      toast.error('Wystąpił błąd podczas wysyłania linku do resetu hasła.', { position: 'bottom-left' });
    }
    return;
  }
  toast.success('Link do resetu hasła został wysłany na podany adres email.', { position: 'bottom-left' });
};

export const passwordReset = async (password: string, token: string) => {
  const body = { newPassword: password };
  const result: any = await axiosInstance.put('/v1/user/password-reset/update?token=' + token, JSON.stringify(body));
  if (result?.isAxiosError) {
    const status = result?.response?.status;
    if (status === 410) {
      toast.error('Link do resetu hasła wygasł. Poproś o nowy link.', { position: 'bottom-left' });
    } else {
      toast.error('Nie udało się ustawić nowego hasła. Link może być nieprawidłowy lub wygasły.', { position: 'bottom-left' });
    }
    return;
  }
  toast.success('Nowe hasło zostało poprawnie zapisane.', { position: 'bottom-left' });
};

export const checkToken = async (token: string): Promise<boolean> => {
  // The interceptor resolves (instead of rejecting) on HTTP errors, and the API returns
  // 200 with a null body for invalid/expired tokens — so validity must be read from the body.
  const result: any = await axiosInstance.get('/v1/user/password-reset/details?token=' + token);
  if (result?.isAxiosError) {
    return false;
  }
  return result?.data != null;
};

export const getProfile = createAsyncThunk('user/getProfile', async () => {
  try {
    const result = await axiosInstance.get<UserModel>('/v1/profile');
    return result.data;
  } catch (e) {
    console.log(e);
  }
});

export const getUserProfile = createAsyncThunk('user/getUserProfile', async () => {
  try {
    const result = await axiosInstance.get<UserModelProfile>('/v1/profile');
    return result.data;
  } catch (e) {
    console.log(e);
  }
});

export const putUserProfile = createAsyncThunk('user/putUserProfile', async (user: UserModelProfile, thunkAPI): Promise<boolean> => {
  try {
    await axiosInstance.put<UserModelProfile>('/v1/profile', user);
    thunkAPI.dispatch(openInfoBox('Dane użytkownika zostały zaapisane.'));
    return true;
  } catch (e) {
    console.log(e);
  }
  return false;
});
